import { Mail, Phone } from 'lucide-react';
import { SectionHeader } from '@/components/brand/BrandKit';
import { LeadConnectForm } from '@/components/LeadConnectForm';
import { RESERVATIONS_EMAIL, RESERVATIONS_PHONES } from '@/data/transportPricing';
import { bt } from '@/i18n/bookingI18n';

export function FormEmbedSection({ id, testid, chip, title, desc, formId, formName, formTestid, bg = 'bg-[#FAFAFA]', height = 760, showContact = false }) {
  return (
    <section id={id} data-testid={testid} className={`${bg} py-16 sm:py-24`}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader chip={chip} title={title} desc={desc} align="center" />
        <div className="mt-10 rounded-2xl border border-black/10 bg-white p-4 sm:p-6 shadow-sm">
          <LeadConnectForm formId={formId} formName={formName} height={height} testid={formTestid} />
        </div>
        {showContact && <ManagedContactStrip className="mt-8" />}
      </div>
    </section>
  );
}

export function ManagedContactStrip({ className = '', lang = 'en' }) {
  return (
    <div className={`rounded-2xl bg-[#121212] text-white p-6 sm:p-7 ${className}`}>
      <p className="font-heading font-bold text-[11px] tracking-[0.2em] uppercase text-[#EE5A01]">{bt(lang, 'reservations247')}</p>
      <div className="mt-4 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-8">
        <a href={`mailto:${RESERVATIONS_EMAIL}`} className="flex items-center gap-2 font-body text-sm text-white/90 hover:text-white transition-colors"><Mail className="w-4 h-4 text-[#EE5A01]" /> {RESERVATIONS_EMAIL}</a>
        <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
          {RESERVATIONS_PHONES.map((p) => (
            <a key={p} href={`tel:${p.replace(/\s/g, '')}`} dir="ltr" className="flex items-center gap-2 font-body text-sm text-white/90 hover:text-white transition-colors"><Phone className="w-4 h-4 text-[#EE5A01]" /> {p}</a>
          ))}
        </div>
      </div>
    </div>
  );
}
